// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"socialbox_wrapper__24HqQ","text":"socialbox_text__oElY5","container":"socialbox_container__3Bi0X"};